import React from 'react';
import DocumentoNoDisponible from './DocumentoNoDisponible';

const CompendioCap3 = () => (
  <DocumentoNoDisponible titulo="Compendio Estadístico 2017 - 2021 · Capítulo 3" />
);

export default CompendioCap3;
